import React from 'react';
import { useForm, useFormState } from 'react-hook-form';

import { Message } from '@components';
import { FormFieldset, TextField } from '@Forms/fields.jsx';
import { urlFormat } from '@Forms/formatters.js';
import { errorsFromMutate } from '@Forms/utils.js';
import { ButtonSpinnerIcon } from '@svgs';

export const SocialForm = ({ mutation, locationData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setError,
    control,
    reset,
    resetField,
    trigger,
    watch,
  } = useForm({
    defaultValues: locationData,
    mode: 'onBlur',
  });
  const { isValid } = useFormState({ control });

  const onSubmit = (data) => {
    mutation.mutate(data, {
      onError: (error) => {
        // handle server-side validations and errors
        const errorsList = errorsFromMutate(error);
        errorsList.forEach(({ field, error }) => setError(field, error));
      },
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={
        `sb-manage-content-form ` +
        (mutation.isPending ? 'sb-form-disabled' : '')
      }
    >
      <FormFieldset legend="Social profiles used for linking">
        <TextField
          register={register}
          error={errors.facebook_url}
          options={{ onChange: urlFormat }}
          name="facebook_url"
          label="Facebook"
          placeholder={`https://www.facebook.com/yourbrand/`}
        />
        <TextField
          register={register}
          error={errors.linkedin_url}
          options={{ onChange: urlFormat }}
          name="linkedin_url"
          label="LinkedIn"
          placeholder={`https://www.linkedin.com/company/yourbrand`}
        />
        <TextField
          register={register}
          error={errors.twitter_url}
          options={{ onChange: urlFormat }}
          name="twitter_url"
          label="X (formally Twitter) "
          placeholder={`https://x.com/yourbrand`}
        />
        <TextField
          register={register}
          error={errors.yelp_url}
          options={{ onChange: urlFormat }}
          name="yelp_url"
          label="Yelp"
          placeholder={`https://www.yelp.com/biz/yourbrand`}
        />
        <TextField
          register={register}
          error={errors.youtube_url}
          options={{ onChange: urlFormat }}
          name="youtube_url"
          label="YouTube"
          placeholder={`https://www.youtube.com/yourbrand/videos`}
        />
        <TextField
          register={register}
          error={errors.instagram_url}
          options={{ onChange: urlFormat }}
          name="instagram_url"
          label="Instagram"
          placeholder={`https://www.instagram.com/yourbrand`}
        />
        <TextField
          register={register}
          error={errors.angieslist_url}
          options={{ onChange: urlFormat }}
          name="angieslist_url"
          label="Angi (formerly Angie's List)"
          placeholder={`https://www.angi.com/companylist/us/wa/seattle/yourbrand`}
        />
        <TextField
          register={register}
          error={errors.pinterest_url}
          options={{ onChange: urlFormat }}
          name="pinterest_url"
          label="Pinterest"
          placeholder={`https://www.pinterest.com/yourbrand/`}
        />
        <TextField
          register={register}
          error={errors.snapchat_url}
          options={{ onChange: urlFormat }}
          name="snapchat_url"
          label="Snapchat"
          placeholder={`https://www.snapchat.com/add/yourbrand`}
        />
        <TextField
          register={register}
          error={errors.careerplug_url}
          options={{ onChange: urlFormat }}
          name="careerplug_url"
          label="CareerPlug"
          placeholder={`https://yourbrand.careerplug.com/jobs`}
        />
      </FormFieldset>
      <div className="sb-manage-content-button-bar">
        <div className="sb-flex">
          {/*<button className="sb-btn-cancel sb-btn" onClick={resetForm}>Cancel</button>*/}
          <button
            type="submit"
            className="sb-btn sb-btn-save"
            disabled={mutation.isPending}
          >
            {mutation.isPending ? 'Publishing...' : 'Publish changes'}
            {mutation.isPending && <ButtonSpinnerIcon />}
          </button>
        </div>
        {!isValid && (
          <Message messageStyle="error" title="Please review your form" />
        )}
        {mutation.isError && (
          <Message
            messageStyle="error"
            title="Error publishing changes"
            message="Please review your form"
          />
        )}
        {mutation.isSuccess && (
          <Message messageStyle="success" title="Successfully published" />
        )}
      </div>
    </form>
  );
};
